const faqs = [
  {
    question: "Dans quel délai intervenez-vous à Erstein ?",
    answer: "Erstein est à moins de 20 minutes de notre atelier. Pour une urgence, nous intervenons en 2 à 4 heures. Pour une réparation programmée, nous vous proposons un rendez-vous dans les 24 heures. Les urgences sont traitées en priorité le jour même.",
  },
  {
    question: "Y a-t-il des frais de déplacement à Erstein ?",
    answer: "Non, le déplacement est entièrement gratuit à Erstein comme dans tout le Bas-Rhin. Vous ne payez que l'intervention réalisée, et seulement si nous réparons votre fenêtre. Le devis est gratuit et sans engagement.",
  },
  {
    question: "Quels types de fenêtres réparez-vous à Erstein ?",
    answer: "Nous réparons tous les types de fenêtres présents à Erstein : PVC des lotissements neufs, aluminium des immeubles récents, bois traditionnel du centre-ville. Nous travaillons avec les pièces Ferco, GU, Roto, Maco, Siegenia et bien d'autres. Quel que soit le mécanisme, nous trouvons la solution adaptée. Chaque pièce remplacée est garantie 10 ans.",
  },
];

export default function FAQ() {
  return (
    <section className="bg-white py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-semibold text-[#1E3A47] mb-3">
            Questions fréquentes à Erstein
          </h2>
          <p className="text-[#243038] text-sm md:text-base">
            Tout ce que vous devez savoir sur nos interventions à Erstein.
          </p>
        </div>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-[#EEF2F4] rounded-2xl border border-[#D7E0E4] p-6 md:p-8"
            >
              <h3 className="text-base md:text-lg font-semibold text-[#1E3A47] mb-3">
                {faq.question}
              </h3>
              <p className="text-sm md:text-base text-[#243038] leading-relaxed">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}